import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { setAdminAuthHandler } from './utils/api'

setAdminAuthHandler(() => {
  const redirect = router.currentRoute.value.fullPath
  router.replace({
    path: '/set',
    query: {
      expired: '1',
      ...(redirect && redirect !== '/set' ? { redirect } : {})
    }
  })
})

createApp(App).use(router).mount('#app')
